import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_LOCK_EXPOSURE_ACTION_TYPE } from '../actions/lockExposure.actions';

const initialState = null;

const lockExposureReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_LOCK_EXPOSURE_ACTION_TYPE.SET_LOCK_EXPOSURE:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default lockExposureReducer;
